(function () {
  if (window.ViewsDepthRooms) return;

  var VERT = 'attribute vec2 aPos;varying vec2 vUv;void main(){vUv=aPos*0.5+0.5;gl_Position=vec4(aPos,0.0,1.0);}';

  var FRAG = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'varying vec2 vUv;',
    'uniform sampler2D uImgA;uniform sampler2D uDepA;uniform sampler2D uSubA;uniform sampler2D uMskA;',
    'uniform sampler2D uImgB;uniform sampler2D uDepB;uniform sampler2D uSubB;uniform sampler2D uMskB;',
    'uniform vec2 uScaleA;uniform vec2 uCenterA;uniform vec2 uTexelA;uniform float uHasSubA;uniform float uInvA;uniform float uStrengthA;',
    'uniform vec2 uScaleB;uniform vec2 uCenterB;uniform vec2 uTexelB;uniform float uHasSubB;uniform float uInvB;uniform float uStrengthB;',
    'uniform vec2 uPointer;uniform float uInset;uniform float uProgress;uniform float uActive;uniform vec2 uFocus;uniform vec2 uTravel;uniform float uLight;uniform float uMotion;uniform vec2 uPx;uniform float uReach;',
    'float depthAt(sampler2D dep, vec2 uv, vec2 texel, float inv){',
    '  float d = texture2D(dep, uv).r * 0.4;',
    '  d += texture2D(dep, uv + vec2(texel.x, 0.0)).r * 0.15;',
    '  d += texture2D(dep, uv - vec2(texel.x, 0.0)).r * 0.15;',
    '  d += texture2D(dep, uv + vec2(0.0, texel.y)).r * 0.15;',
    '  d += texture2D(dep, uv - vec2(0.0, texel.y)).r * 0.15;',
    '  return mix(d, 1.0 - d, inv);',
    '}',
    'float dither(vec2 p){',
    '  return fract(52.9829189 * fract(dot(p, vec2(0.06711056, 0.00583715))));',
    '}',
    'float edgeAt(sampler2D dep, vec2 uv, vec2 texel){',
    '  float gx = texture2D(dep, uv + vec2(texel.x * 2.0, 0.0)).r - texture2D(dep, uv - vec2(texel.x * 2.0, 0.0)).r;',
    '  float gy = texture2D(dep, uv + vec2(0.0, texel.y * 2.0)).r - texture2D(dep, uv - vec2(0.0, texel.y * 2.0)).r;',
    '  return smoothstep(0.08, 0.35, abs(gx) + abs(gy));',
    '}',
    'vec4 scene(sampler2D img, sampler2D dep, sampler2D sub, sampler2D msk, float hasSub, float inv, vec2 scale, vec2 center, vec2 texel, float strength, float zoom, float dolly, float blur, vec2 travel, float turn){',
    '  vec2 q = 0.5 + (vUv - 0.5) / (1.0 + uInset);',
    '  q = uFocus + (q - uFocus) / zoom + travel;',
    '  vec2 camera = q - 0.5;',
    '  q = 0.5 + camera / (1.0 + camera.x * turn);',
    '  vec2 uv = center + (q - 0.5) * scale;',
    '  vec2 push = (uPointer * strength + (q - uFocus) * dolly) * scale;',
    '  float d = depthAt(dep, uv, texel, inv);',
    '  d = depthAt(dep, uv + (0.5 - d) * push, texel, inv);',
    '  d = depthAt(dep, uv + (0.5 - d) * push, texel, inv);',
    '  float ridge = edgeAt(dep, uv + (0.5 - d) * push, texel);',
    '  float edge = ridge * (1.0 - hasSub);',
    '  vec2 suv = uv + (0.5 - d) * push * (1.0 - 0.35 * edge);',
    '  vec2 vuv = uv + 0.5 * push;',
    '  vec3 c = texture2D(img, suv).rgb;',
    '  if (hasSub > 0.5) {',
    '    vec4 s = texture2D(sub, vuv);',
    '    c = c * (1.0 - s.a) + s.rgb;',
    '    d = mix(d, 0.0, s.a);',
    '  }',
    '  if (blur > 0.0) {',
    '    vec2 spread = blur * (0.6 + 0.4 * ridge) * uPx * scale / (zoom * (1.0 + uInset));',
    '    float jitter = dither(mod(gl_FragCoord.xy, 64.0));',
    '    vec2 axis = normalize(vec2(uTravel.x, uTravel.y * 0.35));',
    '    vec3 acc = vec3(0.0);',
    '    float weights = 0.0;',
    '    for (int i = 0; i < TAPS; i++) {',
    '      float fi = (float(i) + jitter) / float(TAPS) * 2.0 - 1.0;',
    '      float weight = exp(-fi * fi * 2.5);',
    '      vec2 off = axis * fi * spread;',
    '      vec3 t = texture2D(img, suv + off).rgb;',
    '      if (hasSub > 0.5) {',
    '        vec4 s2 = texture2D(sub, vuv + off);',
    '        t = t * (1.0 - s2.a) + s2.rgb;',
    '      }',
    '      acc += t * weight;',
    '      weights += weight;',
    '    }',
    '    c = acc / weights;',
    '  }',
    '  vec2 lightAt = 0.5 + uPointer * 0.5;',
    '  float glow = 1.0 - smoothstep(0.0, 0.9, distance(q, lightAt));',
    '  c *= 1.0 + uLight * (1.0 - d) * glow;',
    '  return vec4(c, texture2D(msk, suv).r);',
    '}',
    'void main(){',
    '  if (uActive < 0.5) {',
    '    vec4 a = scene(uImgA, uDepA, uSubA, uMskA, uHasSubA, uInvA, uScaleA, uCenterA, uTexelA, uStrengthA, 1.0, 0.0, 0.0, vec2(0.0), 0.0);',
    '    gl_FragColor = vec4(a.rgb, 1.0);',
    '    return;',
    '  }',
    '  float p = uProgress;',
    '  float departure = smoothstep(0.0, 0.60, p);',
    '  float arrival = smoothstep(0.40, 1.0, p);',
    '  float bell = pow(sin(3.14159 * p), 6.0);',
    '  float m = uMotion;',
    '  float blur = bell * m * uReach;',
    '  vec4 a = scene(uImgA, uDepA, uSubA, uMskA, uHasSubA, uInvA, uScaleA, uCenterA, uTexelA, uStrengthA, 1.0 + 0.065 * departure * m, 0.0, blur, uTravel * 0.012 * departure * m, uTravel.x * 0.10 * departure * m);',
    '  vec4 b = scene(uImgB, uDepB, uSubB, uMskB, uHasSubB, uInvB, uScaleB, uCenterB, uTexelB, uStrengthB, 1.0 + 0.025 * (1.0 - arrival) * m, 0.0, blur, -uTravel * 0.004 * (1.0 - arrival) * m, -uTravel.x * 0.04 * (1.0 - arrival) * m);',
    '  float change = smoothstep(0.48, 0.52, p);',
    '  vec3 c = mix(a.rgb, b.rgb, change) * (1.0 - bell * 0.035);',
    '  gl_FragColor = vec4(c, 1.0);',
    '}'
  ].join('\n');

  var UNIFORMS = ['uImgA', 'uDepA', 'uSubA', 'uMskA', 'uImgB', 'uDepB', 'uSubB', 'uMskB', 'uScaleA', 'uCenterA', 'uTexelA', 'uHasSubA', 'uInvA', 'uStrengthA',
    'uScaleB', 'uCenterB', 'uTexelB', 'uHasSubB', 'uInvB', 'uStrengthB', 'uPointer', 'uInset', 'uProgress', 'uActive', 'uFocus', 'uTravel', 'uLight', 'uMotion', 'uPx', 'uReach'];

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarse = window.matchMedia('(hover: none) and (pointer: coarse)');
  var narrow = window.matchMedia('(max-width: 1023px)');
  var instances = new Map();

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(a, b, t) { t = clamp((t - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      if (!src) { resolve(null); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      var timer = setTimeout(function () { reject(new Error('Image indisponible')); }, 12000);
      img.onload = function () { clearTimeout(timer); resolve(img); };
      img.onerror = function () { clearTimeout(timer); reject(new Error('Image indisponible')); };
      img.src = src;
    });
  }

  function compile(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
    return shader;
  }

  function makeTexture(gl, img, kind) {
    var tex = gl.createTexture();
    var format = kind === 'alpha' ? gl.RGBA : kind === 'rgb' ? gl.RGB : gl.LUMINANCE;
    gl.activeTexture(gl.TEXTURE7);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    if (kind === 'alpha') gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
    if (kind === 'mask') {
      gl.texImage2D(gl.TEXTURE_2D, 0, format, img.w, img.h, 0, format, gl.UNSIGNED_BYTE, img.bytes);
    } else if (img) {
      gl.texImage2D(gl.TEXTURE_2D, 0, format, format, gl.UNSIGNED_BYTE, img);
    } else {
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0]));
    }
    if (kind === 'alpha') gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    return tex;
  }

  function boxBlur(field, w, h, r) {
    var span = 2 * r + 1;
    var tmp = new Float32Array(field.length);
    var x, y, i, sum, row;
    for (y = 0; y < h; y++) {
      row = y * w;
      sum = field[row] * (r + 1);
      for (i = 1; i <= r; i++) sum += field[row + (i < w ? i : w - 1)];
      for (x = 0; x < w; x++) {
        tmp[row + x] = sum / span;
        sum += field[row + Math.min(x + r + 1, w - 1)] - field[row + Math.max(x - r, 0)];
      }
    }
    for (x = 0; x < w; x++) {
      sum = tmp[x] * (r + 1);
      for (i = 1; i <= r; i++) sum += tmp[(i < h ? i : h - 1) * w + x];
      for (y = 0; y < h; y++) {
        field[y * w + x] = sum / span;
        sum += tmp[Math.min(y + r + 1, h - 1) * w + x] - tmp[Math.max(y - r, 0) * w + x];
      }
    }
  }

  function lattice(x, y, seed) {
    var n = Math.sin(x * 127.1 + y * 311.7 + seed * 74.7) * 43758.5453;
    return n - Math.floor(n);
  }

  function addGrain(field, w, h, cx, cy, amp, seed) {
    for (var y = 0; y < h; y++) {
      var gy = (y / h) * cy, y0 = Math.floor(gy), fy = gy - y0;
      var sy = fy * fy * (3 - 2 * fy);
      for (var x = 0; x < w; x++) {
        var gx = (x / w) * cx, x0 = Math.floor(gx), fx = gx - x0;
        var sx = fx * fx * (3 - 2 * fx);
        var a = lattice(x0, y0, seed), b = lattice(x0 + 1, y0, seed);
        var c = lattice(x0, y0 + 1, seed), d = lattice(x0 + 1, y0 + 1, seed);
        var top = a + (b - a) * sx;
        var bottom = c + (d - c) * sx;
        field[y * w + x] += (top + (bottom - top) * sy - 0.5) * 2 * amp;
      }
    }
  }

  function buildDepth(img, invert, subject) {
    var w = 256;
    var h = Math.max(1, Math.round(256 * img.naturalHeight / img.naturalWidth));
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    var data = ctx.getImageData(0, 0, w, h).data;
    var n = w * h;
    var field = new Float32Array(n);
    var i, v;
    for (i = 0; i < n; i++) {
      v = data[i * 4] / 255;
      field[i] = invert ? 1 - v : v;
    }
    boxBlur(field, w, h, 11);
    boxBlur(field, w, h, 11);
    if (subject) {
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(subject, 0, 0, w, h);
      var sd = ctx.getImageData(0, 0, w, h).data;
      var mask = new Float32Array(n);
      for (i = 0; i < n; i++) mask[i] = sd[i * 4 + 3] / 255;
      boxBlur(mask, w, h, 9);
      boxBlur(mask, w, h, 9);
      for (i = 0; i < n; i++) field[i] *= 1 - 0.85 * clamp(mask[i], 0, 1);
    }
    addGrain(field, w, h, 6, 5, 0.055, 1);
    addGrain(field, w, h, 14, 11, 0.026, 2);
    var bytes = new Uint8Array(n);
    for (i = 0; i < n; i++) bytes[i] = Math.round(clamp(field[i], 0.02, 0.98) * 255);
    return {
      sample: function (x, y) {
        var col = clamp(Math.round(x * (w - 1)), 0, w - 1);
        var row = clamp(Math.round(y * (h - 1)), 0, h - 1);
        var d = data[(row * w + col) * 4] / 255;
        return invert ? 1 - d : d;
      },
      mask: { w: w, h: h, bytes: bytes }
    };
  }

  function parseData(root) {
    var node = root.querySelector('script[data-depth-rooms-data]');
    if (!node) return [];
    var blocks;
    try { blocks = JSON.parse(node.textContent); } catch (e) { return []; }
    var scenes = [];
    blocks.forEach(function (b) {
      if (b.type === 'scene') { b.hotspots = []; scenes.push(b); }
      else if (b.type === 'hotspot' && scenes.length) scenes[scenes.length - 1].hotspots.push(b);
    });
    return scenes;
  }

  function create(root) {
    var scenes = parseData(root);
    var canvas = root.querySelector('.depth-rooms__canvas');
    if (!scenes.length || !canvas) return null;

    if (canvas.dataset.glUsed) {
      var fresh = canvas.cloneNode(false);
      fresh.removeAttribute('data-gl-used');
      canvas.replaceWith(fresh);
      canvas = fresh;
    }

    var isNarrow = narrow.matches;
    var isTouch = coarse.matches;
    var motionOff = reduceMotion.matches || root.dataset.motion === 'off';
    var strength = (isNarrow ? Number(root.dataset.intensityMobile) : Number(root.dataset.intensity)) / 1000;
    if (motionOff) strength = 0;
    var idle = root.dataset.idle === 'true' && !motionOff;
    var wantGyro = root.dataset.gyro === 'true' && isTouch && !motionOff && 'DeviceOrientationEvent' in window;
    var duration = Number(root.dataset.duration) || 1100;
    if (motionOff) duration = 450;

    var gl = motionOff ? null : canvas.getContext('webgl', { antialias: false, alpha: false, premultipliedAlpha: false, powerPreference: 'low-power' })
      || canvas.getContext('experimental-webgl');
    canvas.dataset.glUsed = '1';

    var state = {
      root: root, canvas: canvas, gl: gl, scenes: scenes, uniforms: {}, program: null, buffer: null,
      current: clamp(Number(root.dataset.startScene) || 0, 0, scenes.length - 1), transition: null, mode: gl ? 'gl' : 'static', loadingTarget: null,
      target: { x: 0, y: 0 }, current2: { x: 0, y: 0 }, lastInput: -1e9,
      visible: false, raf: 0, destroyed: false, gyroBase: null, gyroActive: false,
      cleanups: [], rect: { w: 1, h: 1 }, blank: null, interacted: false, createdAt: performance.now(), lastPaint: 0
    };

    var dom = {
      layers: Array.prototype.slice.call(root.querySelectorAll('.depth-rooms__layer')),
      fallbacks: Array.prototype.slice.call(root.querySelectorAll('.depth-rooms__fallback')),
      counter: root.querySelector('.depth-rooms__counter'),
      title: root.querySelector('.depth-rooms__title'),
      sceneButtons: Array.prototype.slice.call(root.querySelectorAll('[data-scene-index]')),
      status: root.querySelector('.depth-rooms__status'),
      prev: root.querySelector('.depth-rooms__arrow--prev'),
      next: root.querySelector('.depth-rooms__arrow--next'),
      card: root.querySelector('.depth-rooms__card'),
      hint: root.querySelector('.depth-rooms__hint'),
      gyroButton: root.querySelector('.depth-rooms__gyro'),
      hotOpen: null,
      returnFocus: null
    };

    scenes.forEach(function (scene, i) {
      scene.index = i;
      scene.layer = dom.layers.find(function (l) { return l.dataset.sceneId === scene.id; }) || null;
      scene.fallback = dom.fallbacks.find(function (f) { return f.dataset.sceneId === scene.id; }) || null;
      scene.ratio = Number(scene.ratio) || 1.5;
      scene.focal = [Number(scene.focal[0]) || 50, Number(scene.focal[1]) || 50];
      scene.hasSub = Boolean(scene.subject && scene.background);
      scene.relief = clamp(Number(scene.relief) || 100, 25, 200) / 100;
      scene.frame = (scene.frame || [0, 0, 100, 100]).map(Number);
      if (scene.frame[2] <= scene.frame[0]) { scene.frame[0] = 0; scene.frame[2] = 100; }
      if (scene.frame[3] <= scene.frame[1]) { scene.frame[1] = 0; scene.frame[3] = 100; }
      scene.tex = null;
      scene.loading = null;
      scene.sample = null;
      scene.hotspots.forEach(function (h) {
        h.el = scene.layer ? scene.layer.querySelector('[data-spot-id="' + h.id + '"]') : null;
        h.x = clamp(Number(h.x) || 0, 0, 100);
        h.y = clamp(Number(h.y) || 0, 0, 100);
        h.d = 0.5;
      });
    });

    function sources(scene) {
      var useMobile = isNarrow && !scene.hasSub;
      return {
        image: scene.hasSub ? (isNarrow ? scene.backgroundMobile : scene.background) : (useMobile ? scene.imageMobile : scene.image),
        depth: useMobile ? scene.depthMobile : scene.depth,
        subject: scene.hasSub ? (isNarrow ? scene.subjectMobile : scene.subject) : null,
        ratio: useMobile ? (Number(scene.ratioMobile) || scene.ratio) : scene.ratio,
        focal: useMobile ? scene.focalMobile : scene.focal
      };
    }

    function loadScene(scene) {
      if (scene.loading) return scene.loading;
      var src = sources(scene);
      scene.useRatio = src.ratio;
      scene.useFocal = [Number(src.focal[0]) || 50, Number(src.focal[1]) || 50];
      computeMap(scene);
      if (!gl || motionOff) { scene.loading = Promise.resolve(scene); return scene.loading; }
      scene.loading = Promise.all([loadImage(src.image), loadImage(src.depth), loadImage(src.subject)]).then(function (imgs) {
        if (state.destroyed) return scene;
        var built = buildDepth(imgs[1], scene.invert, imgs[2]);
        scene.sample = built.sample;
        scene.depthSize = { w: imgs[1].naturalWidth, h: imgs[1].naturalHeight };
        scene.hotspots.forEach(function (h) { h.d = h.onSubject && scene.hasSub ? 0 : scene.sample(h.x / 100, h.y / 100); });
        if (gl) {
          scene.tex = {
            img: makeTexture(gl, imgs[0], 'rgb'),
            dep: makeTexture(gl, imgs[1], 'lum'),
            sub: imgs[2] ? makeTexture(gl, imgs[2], 'alpha') : state.blank,
            msk: makeTexture(gl, built.mask, 'mask')
          };
        }
        computeMap(scene);
        if (gl) rebind();
        return scene;
      }).catch(function () {
        scene.loading = null;
        scene.failed = true;
        return scene;
      });
      return scene.loading;
    }

    function placeBand(size, boxA, boxB, fallback, headFirst) {
      var visible = size / (1 + strength * 1.3);
      var margin = 0.025;
      var a = Math.max(0, boxA - margin), b = Math.min(1, boxB + margin);
      var center;
      if (b - a <= visible) center = (a + b) / 2;
      else center = headFirst ? a + visible / 2 : (a + b) / 2;
      if (boxA <= 0.001 && boxB >= 0.999) center = fallback;
      return clamp(center, size / 2, 1 - size / 2);
    }

    function computeMap(scene) {
      if (!scene.useRatio) return;
      var containerRatio = state.rect.w / Math.max(1, state.rect.h);
      var sx = 1, sy = 1;
      if (containerRatio > scene.useRatio) sy = scene.useRatio / containerRatio; else sx = containerRatio / scene.useRatio;
      var box = scene.frame;
      var cx = placeBand(sx, box[0] / 100, box[2] / 100, scene.useFocal[0] / 100, false);
      if (isNarrow && Number(scene.mobileCenterX) > 0) cx = clamp(Number(scene.mobileCenterX) / 100, sx / 2, 1 - sx / 2);
      var cyTop = placeBand(sy, box[1] / 100, box[3] / 100, scene.useFocal[1] / 100, true);
      scene.map = { sx: sx, sy: sy, cx: cx, cy: 1 - cyTop };
      syncFallback(scene);
    }

    function syncFallback(scene) {
      if (!scene.fallback || !scene.map) return;
      var m = scene.map;
      var inset = 1 + strength * 1.3;
      var px = m.sx >= 0.999 ? 50 : ((m.cx - 0.5 * m.sx) / (1 - m.sx)) * 100;
      var py = m.sy >= 0.999 ? 50 : (((1 - m.cy) - 0.5 * m.sy) / (1 - m.sy)) * 100;
      var imgs = scene.fallback.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.objectPosition = px.toFixed(3) + '% ' + py.toFixed(3) + '%';
        imgs[i].style.transform = 'scale(' + inset.toFixed(4) + ')';
        imgs[i].style.transformOrigin = '50% 50%';
      }
    }

    function bindSlot(slot, scene) {
      if (!gl || !scene.tex || !scene.map) return;
      var base = slot === 'A' ? 0 : 3;
      gl.activeTexture(gl.TEXTURE0 + base); gl.bindTexture(gl.TEXTURE_2D, scene.tex.img);
      gl.activeTexture(gl.TEXTURE0 + base + 1); gl.bindTexture(gl.TEXTURE_2D, scene.tex.dep);
      gl.activeTexture(gl.TEXTURE0 + base + 2); gl.bindTexture(gl.TEXTURE_2D, scene.tex.sub);
      gl.activeTexture(gl.TEXTURE0 + (slot === 'A' ? 6 : 7)); gl.bindTexture(gl.TEXTURE_2D, scene.tex.msk);
      var u = state.uniforms;
      gl.uniform2f(u['uScale' + slot], scene.map.sx, scene.map.sy);
      gl.uniform2f(u['uCenter' + slot], scene.map.cx, scene.map.cy);
      gl.uniform2f(u['uTexel' + slot], 2 / scene.depthSize.w, 2 / scene.depthSize.h);
      gl.uniform1f(u['uHasSub' + slot], scene.hasSub ? 1 : 0);
      gl.uniform1f(u['uInv' + slot], scene.invert ? 1 : 0);
      gl.uniform1f(u['uStrength' + slot], strength * scene.relief);
    }

    function rebind() {
      if (!gl) return;
      var cur = scenes[state.current];
      if (cur && cur.tex && cur.map) bindSlot('A', cur);
      var tr = state.transition;
      if (tr && tr.to.tex && tr.to.map) bindSlot('B', tr.to);
    }

    function setupGL() {
      var program = gl.createProgram();
      gl.attachShader(program, compile(gl, gl.VERTEX_SHADER, VERT));
      gl.attachShader(program, compile(gl, gl.FRAGMENT_SHADER, '#define TAPS ' + (isNarrow ? 10 : 16) + '\n' + FRAG));
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(program));
      gl.useProgram(program);
      state.program = program;
      var buffer = gl.createBuffer();
      state.buffer = buffer;
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var aPos = gl.getAttribLocation(program, 'aPos');
      gl.enableVertexAttribArray(aPos);
      gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);
      UNIFORMS.forEach(function (n) { state.uniforms[n] = gl.getUniformLocation(program, n); });
      var u = state.uniforms;
      gl.uniform1i(u.uImgA, 0); gl.uniform1i(u.uDepA, 1); gl.uniform1i(u.uSubA, 2); gl.uniform1i(u.uMskA, 6);
      gl.uniform1i(u.uImgB, 3); gl.uniform1i(u.uDepB, 4); gl.uniform1i(u.uSubB, 5); gl.uniform1i(u.uMskB, 7);
      gl.uniform2f(u.uPx, 1 / 1280, 1 / 720);
      gl.uniform1f(u.uReach, 64);
      gl.uniform1f(u.uInset, strength * 1.3);
      gl.uniform1f(u.uProgress, 0);
      gl.uniform1f(u.uActive, 0);
      gl.uniform2f(u.uFocus, 0.5, 0.5);
      gl.uniform2f(u.uTravel, 0, 0);
      gl.uniform1f(u.uLight, motionOff ? 0 : 0.03);
      gl.uniform1f(u.uMotion, motionOff ? 0 : 1);
      gl.uniform2f(u.uPointer, 0, 0);
      state.blank = makeTexture(gl, null, 'alpha');
    }

    function fitViewport() {
      var fit = root.dataset.fit || '';
      var wants = isNarrow ? fit.indexOf('m') !== -1 : fit.indexOf('d') !== -1;
      if (!wants) { root.style.height = ''; return; }
      var top = root.getBoundingClientRect().top + window.scrollY;
      var h = window.innerHeight - top;
      root.style.height = Math.max(isNarrow ? 480 : 440, Math.round(h)) + 'px';
    }

    function resize() {
      fitViewport();
      var r = root.getBoundingClientRect();
      state.rect = { w: Math.max(1, r.width), h: Math.max(1, r.height) };
      if (gl) {
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        var w = Math.round(state.rect.w * dpr), h = Math.round(state.rect.h * dpr);
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
        gl.viewport(0, 0, w, h);
        if (state.uniforms.uPx) {
          gl.uniform2f(state.uniforms.uPx, 1 / state.rect.w, 1 / state.rect.h);
          gl.uniform1f(state.uniforms.uReach, Math.min(80, state.rect.w * 0.055));
        }
      }
      scenes.forEach(function (s) { if (s.useRatio) computeMap(s); });
      var cur = scenes[state.current];
      if (cur.map) bindSlot('A', cur);
      if (state.transition && state.transition.to.map) bindSlot('B', state.transition.to);
      layoutHotspots(scenes[state.current], true);
    }

    function layoutHotspots(scene, force) {
      if (!scene || !scene.map) return;
      var m = scene.map;
      var px = state.current2.x, py = state.current2.y;
      var activeStrength = state.mode === 'gl' ? strength : 0;
      var inset = 1 + activeStrength * 1.3;
      var k = activeStrength * scene.relief * inset;
      scene.hotspots.forEach(function (h) {
        if (!h.el) return;
        var ux = h.x / 100, uy = 1 - h.y / 100;
        var qx = 0.5 + (ux - m.cx) / m.sx, qy = 0.5 + (uy - m.cy) / m.sy;
        var pxp = 0.5 + (qx - 0.5) * inset, pyp = 0.5 + (qy - 0.5) * inset;
        var shift = (0.5 - h.d) * k;
        var left = pxp - shift * px, top = 1 - (pyp - shift * py);
        if (isNarrow) {
          if (Number(h.xm) > 0 && Number(h.ym) > 0) { left = Number(h.xm) / 100 - shift * px; top = Number(h.ym) / 100 + shift * py; }
          left = clamp(left, 0.09, 0.91);
          top = clamp(top, 0.12, 0.72);
        }
        if (force) {
          h.el.style.left = (left * 100).toFixed(3) + '%';
          h.el.style.top = (top * 100).toFixed(3) + '%';
          h.el.style.transform = '';
          h.el.classList.toggle('depth-rooms__spot--flip', left > 0.62);
          h.el.classList.toggle('depth-rooms__spot--hidden', left < -0.02 || left > 1.02 || top < -0.02 || top > 1.02);
          h.base = { left: left, top: top };
        } else if (h.base) {
          var dx = (left - h.base.left) * state.rect.w, dy = (top - h.base.top) * state.rect.h;
          h.el.style.transform = 'translate(' + dx.toFixed(2) + 'px,' + dy.toFixed(2) + 'px)';
        }
      });
    }

    function draw(now) {
      state.raf = 0;
      if (state.destroyed || !state.visible || document.hidden) return;
      var t = now / 1000;
      var tx = state.target.x, ty = state.target.y;
      var since = now - state.lastInput;
      var quiet = since > 1800;
      var breathing = idle && state.mode === 'gl' && quiet && !state.gyroActive && !state.transition && !dom.hotOpen;
      if (breathing) {
        var fade = smooth(1800, 3800, since) * smooth(0, 1600, now - state.createdAt);
        tx = Math.sin(t * 0.24) * 0.30 * fade;
        ty = Math.sin(t * 0.18 + 1.0) * 0.12 * fade;
      } else if (quiet && !state.gyroActive) { tx = 0; ty = 0; }
      var ease = state.gyroActive ? 0.12 : 0.07;
      state.current2.x += (tx - state.current2.x) * ease;
      state.current2.y += (ty - state.current2.y) * ease;

      var tr = state.transition;
      var busy = Boolean(tr);
      if (breathing && now - state.lastPaint < 32) { wake(); return; }
      state.lastPaint = now;
      if (gl) {
        var u = state.uniforms;
        gl.uniform2f(u.uPointer, state.current2.x, state.current2.y);
        if (tr) {
          var p = clamp((now - tr.start) / tr.duration, 0, 1);
          gl.uniform2f(u.uFocus, tr.focus[0], tr.focus[1]);
          gl.uniform2f(u.uTravel, tr.travel[0], tr.travel[1]);
          gl.uniform1f(u.uActive, 1);
          gl.uniform1f(u.uProgress, p);
          if (p >= 0.5 && !tr.swapped) { tr.swapped = true; showMeta(tr.to); }
          if (p >= 1) finishTransition();
        }
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      }
      if (!tr) layoutHotspots(scenes[state.current], false);

      var settled = Math.abs(tx - state.current2.x) < 0.0004 && Math.abs(ty - state.current2.y) < 0.0004;
      if (settled && !breathing && !busy && (!idle || state.mode !== 'gl')) return;
      state.raf = window.requestAnimationFrame(draw);
    }

    function wake() {
      if (!state.raf && state.visible && !state.destroyed) state.raf = window.requestAnimationFrame(draw);
    }

    function setPointer(x, y) {
      state.target.x = clamp(x, -1, 1);
      state.target.y = clamp(y, -1, 1);
      state.lastInput = performance.now();
      wake();
    }

    function showMeta(scene) {
      if (dom.counter) dom.counter.textContent = pad(scene.index + 1) + ' / ' + pad(scenes.length);
      if (dom.title) dom.title.textContent = scene.title || '';
      root.dataset.activeScene = scene.id;
      dom.sceneButtons.forEach(function (button) {
        if (Number(button.dataset.sceneIndex) === scene.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }

    function activateLayer(scene) {
      root.dataset.startScene = scene.index;
      dom.layers.forEach(function (l) {
        var active = l === scene.layer;
        l.classList.remove('is-leaving');
        l.classList.toggle('is-active', active);
        try { l.inert = !active; } catch (e) {}
      });
      dom.fallbacks.forEach(function (f) { f.hidden = f.dataset.sceneId !== scene.id; });
      if (scene.layer) layoutHotspots(scene, true);
    }

    function finishTransition() {
      var tr = state.transition;
      if (!tr) return;
      state.transition = null;
      state.current = tr.to.index;
      var u = state.uniforms;
      bindSlot('A', tr.to);
      gl.uniform1f(u.uActive, 0);
      gl.uniform1f(u.uProgress, 0);
      gl.uniform2f(u.uFocus, 0.5, 0.5);
      root.classList.remove('is-transitioning');
      activateLayer(tr.to);
      preloadAround();
    }

    function go(index, focus, kind) {
      if (state.transition || state.loadingTarget !== null || index === state.current) return;
      var to = scenes[index];
      if (!to) return;
      var delta = (index - state.current + scenes.length) % scenes.length;
      var direction = delta > scenes.length / 2 ? -1 : 1;
      var portal = scenes[state.current].hotspots.find(function (h) { return h.kind === 'passage' && Number(h.target) === index + 1; });
      if (kind !== 'passage' && portal) {
        focus = spotFocus(portal);
      }
      if (!focus) focus = [direction > 0 ? 0.68 : 0.32, 0.5];
      if (kind === 'passage' && Math.abs(focus[0] - 0.5) > 0.08) direction = focus[0] > 0.5 ? 1 : -1;
      closeCard(false);
      dismissHint();
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');
      state.loadingTarget = index;
      var moveFocus = scenes[state.current].layer && scenes[state.current].layer.contains(document.activeElement);
      if (dom.status) dom.status.textContent = 'Ouverture du décor…';
      loadScene(to).then(function () {
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
        state.loadingTarget = null;
        if (dom.status) dom.status.textContent = '';
        if (state.destroyed || state.transition) return;
        if (!to.map) computeMap(to);
        var from = scenes[state.current];
        if (moveFocus) root.focus({ preventScroll: true });
        if (from.layer) { from.layer.inert = true; from.layer.classList.add('is-leaving'); from.layer.classList.remove('is-active'); }
        root.classList.add('is-transitioning');
        if (state.mode !== 'gl' || !to.tex || !from.tex) {
          root.classList.add('is-static');
          state.current = index;
          showMeta(to);
          activateLayer(to);
          root.classList.remove('is-transitioning');
          preloadAround();
          return;
        }
        root.classList.remove('is-static');
        bindSlot('B', to);
        state.transition = {
          to: to, start: performance.now(), duration: duration,
          focus: focus, travel: [direction, (focus[1] - 0.5) * 0.3], swapped: false
        };
        wake();
      }).catch(function () {
        state.loadingTarget = null;
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
        if (dom.status) dom.status.textContent = 'Ce décor est indisponible. Essaie un autre décor.';
      });
    }

    function preloadAround() {
      if (motionOff || !gl || (navigator.connection && navigator.connection.saveData)) return;
      var cur = scenes[state.current];
      var wanted = [];
      cur.hotspots.forEach(function (h) {
        if (h.kind !== 'passage') return;
        var t = clamp((Number(h.target) || 1) - 1, 0, scenes.length - 1);
        if (t !== state.current && wanted.indexOf(t) === -1) wanted.push(t);
      });
      if (scenes.length > 1) {
        var next = (state.current + 1) % scenes.length;
        if (wanted.indexOf(next) === -1) wanted.push(next);
      }
      wanted = wanted.slice(0, 1);
      var i = 0;
      function loadNext() {
        if (state.destroyed || i >= wanted.length) return;
        loadScene(scenes[wanted[i++]]).then(function () { setTimeout(loadNext, 200); }, function () { setTimeout(loadNext, 200); });
      }
      (window.requestIdleCallback || function (fn) { setTimeout(fn, 600); })(loadNext);
    }

    function spotFocus(h) {
      if (!h.el) return [0.5, 0.5];
      var r = h.el.getBoundingClientRect(), rr = root.getBoundingClientRect();
      var cx = (r.left + r.width / 2 - rr.left) / state.rect.w;
      var cy = (r.top + r.height / 2 - rr.top) / state.rect.h;
      return [clamp(cx, 0.1, 0.9), clamp(1 - cy, 0.1, 0.9)];
    }

    function openCard(h) {
      if (!dom.card) return;
      var body = dom.card.querySelector('.depth-rooms__card-body');
      var tpl = root.querySelector('template[data-card-for="' + h.id + '"]');
      if (!body || !tpl) return;
      while (body.firstChild) body.removeChild(body.firstChild);
      body.appendChild(tpl.content.cloneNode(true));
      dom.card.hidden = false;
      dom.card.classList.remove('is-open');
      if (!isNarrow && h.el) {
        var r = h.el.getBoundingClientRect(), rr = root.getBoundingClientRect();
        var cw = dom.card.offsetWidth || 300, ch = dom.card.offsetHeight || 200;
        var x = r.left - rr.left + r.width / 2, y = r.top - rr.top + r.height / 2;
        var left = x > state.rect.w * 0.55 ? x - 28 - cw : x + 28;
        var top = clamp(y - ch / 2, 16, state.rect.h - ch - 76);
        dom.card.style.left = clamp(left, 16, state.rect.w - cw - 16) + 'px';
        dom.card.style.top = top + 'px';
      } else {
        dom.card.style.left = ''; dom.card.style.top = '';
      }
      dom.hotOpen = h;
      h.el.setAttribute('aria-expanded', 'true');
      dom.card.setAttribute('aria-label', h.label || 'Découvrir dans ce décor');
      dom.returnFocus = h.el;
      scenes.forEach(function (s) { s.hotspots.forEach(function (o) { if (o.el) o.el.classList.toggle('is-open', o === h); }); });
      window.requestAnimationFrame(function () {
        dom.card.classList.add('is-open');
        var close = dom.card.querySelector('.depth-rooms__card-close');
        if (close) close.focus({ preventScroll: true });
      });
    }

    function closeCard(restoreFocus) {
      if (!dom.card || dom.card.hidden) return;
      dom.card.classList.remove('is-open');
      dom.card.hidden = true;
      if (dom.hotOpen && dom.hotOpen.el) dom.hotOpen.el.setAttribute('aria-expanded', 'false');
      dom.hotOpen = null;
      scenes.forEach(function (s) { s.hotspots.forEach(function (o) { if (o.el) o.el.classList.remove('is-open'); }); });
      if (restoreFocus && dom.returnFocus) { try { dom.returnFocus.focus({ preventScroll: true }); } catch (e) {} }
      dom.returnFocus = null;
    }

    function dismissHint() {
      if (!dom.hint || state.interacted) return;
      state.interacted = true;
      dom.hint.classList.add('is-hidden');
      try { sessionStorage.setItem('views-depth-rooms-hint', '1'); } catch (e) {}
    }

    function onSpot(event) {
      var el = event.currentTarget;
      var id = el.dataset.spotId;
      var scene = scenes[state.current];
      var h = scene.hotspots.find(function (o) { return o.id === id; });
      if (!h) return;
      event.preventDefault();
      event.stopPropagation();
      dismissHint();
      if (h.kind === 'objet') {
        if (dom.hotOpen === h) closeCard(true); else openCard(h);
      } else {
        var target = clamp((Number(h.target) || 1) - 1, 0, scenes.length - 1);
        if (target === state.current) return;
        go(target, spotFocus(h), 'passage');
      }
    }

    function step(dir) {
      if (scenes.length < 2) return;
      dismissHint();
      var idx = (state.current + dir + scenes.length) % scenes.length;
      go(idx, [dir > 0 ? 0.78 : 0.22, 0.5], 'step');
    }

    function onMouse(event) {
      var r = root.getBoundingClientRect();
      if (event.clientY < r.top - 120 || event.clientY > r.bottom + 120) return;
      setPointer(((event.clientX - r.left) / r.width) * 2 - 1, -((event.clientY - r.top) / r.height) * 2 + 1);
    }

    var touch = { x: 0, y: 0, t: 0 };
    function onTouchStart(event) {
      var p = event.touches[0];
      touch = { x: p.clientX, y: p.clientY, t: performance.now() };
    }
    function onTouchMove(event) {
      if (state.gyroActive) return;
      if (event.touches.length !== 1) return;
      var p = event.touches[0];
      var r = root.getBoundingClientRect();
      setPointer(((p.clientX - r.left) / r.width) * 2 - 1, -(((p.clientY - r.top) / r.height) * 2 - 1));
    }
    function onTouchEnd(event) {
      var p = event.changedTouches[0];
      var dx = p.clientX - touch.x, dy = p.clientY - touch.y;
      if (performance.now() - touch.t < 700 && Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    }

    function onKey(event) {
      if (!state.visible) return;
      if (event.key === 'Escape') { closeCard(true); return; }
      if (dom.card && !dom.card.hidden) {
        if (event.key === 'Tab') {
          var items = Array.prototype.slice.call(dom.card.querySelectorAll('button,a[href]')).filter(function (el) { return !el.disabled; });
          var first = items[0], last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { last.focus(); event.preventDefault(); }
          else if (!event.shiftKey && document.activeElement === last) { first.focus(); event.preventDefault(); }
        }
        return;
      }
      if (event.target && /input|textarea|select/i.test(event.target.tagName)) return;
      if (event.key === 'ArrowRight') { step(1); event.preventDefault(); }
      else if (event.key === 'ArrowLeft') { step(-1); event.preventDefault(); }
    }

    function onOrientation(event) {
      if (event.gamma === null || event.beta === null) return;
      var landscape = window.innerWidth > window.innerHeight;
      var a = landscape ? event.beta : event.gamma;
      var b = landscape ? -event.gamma : event.beta;
      if (!state.gyroBase) state.gyroBase = { a: a, b: b };
      else {
        state.gyroBase.a += (a - state.gyroBase.a) * 0.002;
        state.gyroBase.b += (b - state.gyroBase.b) * 0.002;
      }
      state.gyroActive = true;
      setPointer((a - state.gyroBase.a) / 18, -((b - state.gyroBase.b) / 18));
    }

    function startGyro() {
      window.addEventListener('deviceorientation', onOrientation, { passive: true });
      state.cleanups.push(function () { window.removeEventListener('deviceorientation', onOrientation); });
      root.classList.remove('needs-gyro');
    }

    function requestGyro(fromGesture) {
      var api = window.DeviceOrientationEvent;
      if (typeof api.requestPermission !== 'function') { startGyro(); return; }
      var request;
      try { request = api.requestPermission(); } catch (e) { if (!fromGesture) root.classList.add('needs-gyro'); return; }
      request.then(function (result) {
        if (result === 'granted') {
          try { localStorage.setItem('views-depth-gyro', 'granted'); } catch (e) {}
          startGyro();
        } else {
          try { localStorage.setItem('views-depth-gyro', 'denied'); } catch (e) {}
          root.classList.add('needs-gyro');
        }
      }).catch(function () { root.classList.add('needs-gyro'); });
    }

    function on(el, type, fn, opts) {
      if (!el) return;
      el.addEventListener(type, fn, opts);
      state.cleanups.push(function () { el.removeEventListener(type, fn, opts); });
    }

    if (motionOff) { gl = null; state.gl = null; state.mode = 'static'; }
    if (gl) {
      try { setupGL(); } catch (e) { gl = null; state.gl = null; state.mode = 'static'; }
    }

    on(canvas, 'webglcontextlost', function (e) {
      e.preventDefault();
      if (state.raf) window.cancelAnimationFrame(state.raf);
      state.raf = 0;
      state.transition = null;
      state.mode = 'static';
      root.classList.add('is-static');
      root.classList.remove('is-transitioning');
      activateLayer(scenes[state.current]);
      showMeta(scenes[state.current]);
    });
    on(canvas, 'webglcontextrestored', function () {
      if (!state.destroyed) window.ViewsDepthRooms.init(root);
    });

    resize();
    var first = scenes[state.current];
    loadScene(first).then(function () {
      if (state.destroyed) return;
      computeMap(first);
      if (gl) bindSlot('A', first);
      showMeta(first);
      activateLayer(first);
      root.classList.add('is-ready');
      root.classList.toggle('is-static', state.mode !== 'gl' || !first.tex);

      var io = new IntersectionObserver(function (entries) {
        state.visible = entries[0].isIntersecting;
        if (state.visible) wake();
      }, { rootMargin: '10% 0px' });
      io.observe(root);
      state.cleanups.push(function () { io.disconnect(); });

      var ro = new ResizeObserver(function () { resize(); wake(); });
      ro.observe(root);
      state.cleanups.push(function () { ro.disconnect(); });
      on(window, 'resize', function () { resize(); wake(); }, { passive: true });
      on(window, 'orientationchange', function () { setTimeout(function () { resize(); wake(); }, 250); });
      on(document, 'visibilitychange', function () { if (!document.hidden) wake(); });

      scenes.forEach(function (s) { s.hotspots.forEach(function (h) {
        if (h.el && h.kind === 'objet') { h.el.setAttribute('aria-haspopup', 'dialog'); h.el.setAttribute('aria-expanded', 'false'); }
        on(h.el, 'click', onSpot);
      }); });
      on(dom.prev, 'click', function (e) { e.preventDefault(); step(-1); });
      on(dom.next, 'click', function (e) { e.preventDefault(); step(1); });
      on(dom.card && dom.card.querySelector('.depth-rooms__card-close'), 'click', function (e) { e.preventDefault(); closeCard(true); });
      on(root, 'keydown', onKey);
      dom.sceneButtons.forEach(function (button) {
        on(button, 'click', function () { go(Number(button.dataset.sceneIndex), [0.5, 0.5], 'step'); });
      });
      on(reduceMotion, 'change', function () { window.ViewsDepthRooms.init(root); });
      on(narrow, 'change', function () { window.ViewsDepthRooms.init(root); });
      on(root, 'click', function (e) {
        if (dom.card && !dom.card.hidden && !dom.card.contains(e.target) && !e.target.closest('.depth-rooms__spot')) closeCard(false);
      });

      if (!isTouch) on(window, 'mousemove', onMouse, { passive: true });
      else {
        on(root, 'touchstart', onTouchStart, { passive: true });
        on(root, 'touchmove', onTouchMove, { passive: true });
        on(root, 'touchend', onTouchEnd, { passive: true });
      }

      if (wantGyro) {
        root.classList.add('needs-gyro');
        on(dom.gyroButton, 'click', function (e) { e.preventDefault(); e.stopPropagation(); requestGyro(true); });
      }

      var seen = false;
      try { seen = sessionStorage.getItem('views-depth-rooms-hint') === '1'; } catch (e) {}
      if (dom.hint && !seen) {
        dom.hint.classList.add('is-visible');
        setTimeout(function () { if (!state.destroyed && dom.hint) dom.hint.classList.add('is-hidden'); }, 9000);
      }

      state.visible = true;
      state.lastInput = performance.now() - 2500;
      wake();
      preloadAround();
    }).catch(function () {
      root.classList.remove('is-ready');
    });

    state.go = go;
    state.selectBlock = function (blockId) {
      for (var i = 0; i < scenes.length; i++) {
        var s = scenes[i];
        if (s.id === blockId) { go(i, [0.5, 0.5], 'step'); return; }
        for (var j = 0; j < s.hotspots.length; j++) {
          if (s.hotspots[j].id === blockId) {
            var h = s.hotspots[j];
            var mark = function () { if (h.el) { h.el.classList.add('is-selected'); setTimeout(function () { h.el.classList.remove('is-selected'); }, 2500); } };
            if (i === state.current) mark(); else { go(i, [0.5, 0.5], 'step'); setTimeout(mark, duration + 100); }
            return;
          }
        }
      }
    };
    return state;
  }

  function destroy(root) {
    var state = instances.get(root);
    if (!state) return;
    state.destroyed = true;
    if (state.raf) window.cancelAnimationFrame(state.raf);
    state.cleanups.forEach(function (fn) { fn(); });
    var gl = state.gl;
    if (gl) {
      state.scenes.forEach(function (s) {
        if (!s.tex) return;
        gl.deleteTexture(s.tex.img);
        gl.deleteTexture(s.tex.dep);
        if (s.tex.msk) gl.deleteTexture(s.tex.msk);
        if (s.tex.sub && s.tex.sub !== state.blank) gl.deleteTexture(s.tex.sub);
        s.tex = null;
      });
      if (state.blank) gl.deleteTexture(state.blank);
      if (state.buffer) gl.deleteBuffer(state.buffer);
      if (state.program) gl.deleteProgram(state.program);
      var ext = gl.getExtension('WEBGL_lose_context');
      if (ext) ext.loseContext();
    }
    root.classList.remove('is-ready', 'needs-gyro', 'is-transitioning', 'is-loading', 'is-static');
    instances.delete(root);
  }

  window.ViewsDepthRooms = {
    init: function (root) {
      if (!root) return;
      destroy(root);
      var state = create(root);
      if (state) instances.set(root, state);
    },
    destroy: destroy,
    get: function (root) { return instances.get(root); }
  };

  function boot() {
    document.querySelectorAll('[data-depth-rooms]').forEach(function (root) {
      if (!instances.has(root)) window.ViewsDepthRooms.init(root);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-depth-rooms]');
    if (root) window.ViewsDepthRooms.init(root);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-depth-rooms]');
    if (root) destroy(root);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-depth-rooms]');
    var state = root && instances.get(root);
    var id = event.target.dataset.sceneId || event.target.dataset.spotId;
    if (state && id) state.selectBlock(id);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
